module.exports = __webpack_public_path__ + "static/media/outdoor_icon.413ca6ad.svg";